/**
 * main.js — Script principal do tema Valormaia
 *
 * Organizado em módulos IIFE para evitar poluição do scope global.
 * valormaiaData é injetado via wp_localize_script em inc/enqueue.php
 */

( function ( $, data ) {
    'use strict';

    // ── Módulo: Navegação mobile ──────────────────────────────────────────────
    const Navigation = ( function () {

        const $toggle = $( '.menu-toggle' );
        const $menu   = $( '#primary-menu' );

        function init() {
            if ( ! $toggle.length ) return;
            $toggle.on( 'click', toggle );
            $( document ).on( 'click', closeOnOutside );
            $( document ).on( 'keydown', closeOnEscape );
        }

        function toggle() {
            const isExpanded = $toggle.attr( 'aria-expanded' ) === 'true';
            $toggle.attr( 'aria-expanded', ! isExpanded );
            $menu.toggleClass( 'is-open' );
        }

        function closeOnOutside( e ) {
            if ( ! $( e.target ).closest( '.main-navigation' ).length ) {
                $menu.removeClass( 'is-open' );
                $toggle.attr( 'aria-expanded', 'false' );
            }
        }

        function closeOnEscape( e ) {
            if ( e.key === 'Escape' ) {
                $menu.removeClass( 'is-open' );
                $toggle.attr( 'aria-expanded', 'false' );
                $toggle.trigger( 'focus' );
            }
        }

        return { init };
    } )();

    // ── Módulo: Header sticky com classe ao fazer scroll ──────────────────────
    const StickyHeader = ( function () {

        const $header    = $( '.site-header' );
        const scrolled   = 'is-scrolled';
        let   lastScroll = 0;

        function init() {
            if ( ! $header.length ) return;
            $( window ).on( 'scroll.header', onScroll );
        }

        function onScroll() {
            const current = $( window ).scrollTop();
            $header.toggleClass( scrolled, current > 60 );
            lastScroll = current;
        }

        return { init };
    } )();

    // ── Módulo: Smooth scroll para âncoras ────────────────────────────────────
    const SmoothScroll = ( function () {

        function init() {
            $( document ).on( 'click', 'a[href*="#"]:not([href="#"])', function ( e ) {
                if (
                    location.pathname.replace( /^\//, '' ) === this.pathname.replace( /^\//, '' ) &&
                    location.hostname === this.hostname
                ) {
                    let target = $( this.hash );
                    if ( ! target.length ) {
                        target = $( '[name=' + this.hash.slice( 1 ) + ']' );
                    }
                    if ( target.length ) {
                        e.preventDefault();
                        $( 'html, body' ).animate(
                            { scrollTop: target.offset().top - 80 },
                            600
                        );
                        target.trigger( 'focus' );
                    }
                }
            } );
        }

        return { init };
    } )();

    // ── Módulo: Lazy loading de imagens (nativo + fallback) ───────────────────
    const LazyImages = ( function () {

        function init() {
            if ( 'loading' in HTMLImageElement.prototype ) {
                // Browser suporta lazy loading nativo
                $( 'img[data-src]' ).each( function () {
                    this.src = $( this ).data( 'src' );
                    $( this ).attr( 'loading', 'lazy' );
                } );
            } else if ( 'IntersectionObserver' in window ) {
                const observer = new IntersectionObserver( observerCallback, {
                    rootMargin: '200px 0px',
                } );
                $( 'img[data-src]' ).each( function () {
                    observer.observe( this );
                } );
            }
        }

        function observerCallback( entries, observer ) {
            entries.forEach( function ( entry ) {
                if ( entry.isIntersecting ) {
                    const img = entry.target;
                    img.src = img.dataset.src;
                    img.classList.add( 'is-loaded' );
                    observer.unobserve( img );
                }
            } );
        }

        return { init };
    } )();

    // ── Módulo: Back to top ───────────────────────────────────────────────────
    const BackToTop = ( function () {

        function init() {
            const $btn = $( '#back-to-top' );
            if ( ! $btn.length ) return;

            $( window ).on( 'scroll.btt', function () {
                $btn.toggleClass( 'is-visible', $( window ).scrollTop() > 400 );
            } );

            $btn.on( 'click', function ( e ) {
                e.preventDefault();
                $( 'html, body' ).animate( { scrollTop: 0 }, 400 );
            } );
        }

        return { init };
    } )();

    // ── Módulo: FAQ Accordion (landing Financiamento) ─────────────────────────
    const FaqAccordion = ( function () {

        function init() {
            const items = document.querySelectorAll( '.vm-faq__item' );
            if ( ! items.length ) return;

            items.forEach( function ( item ) {
                const btn    = item.querySelector( '.vm-faq__question' );
                const answer = item.querySelector( '.vm-faq__answer' );
                if ( ! btn || ! answer ) return;

                btn.addEventListener( 'click', function () {
                    const isOpen = item.classList.contains( 'is-open' );

                    // Fecha todos
                    items.forEach( function ( other ) {
                        const otherBtn    = other.querySelector( '.vm-faq__question' );
                        const otherAnswer = other.querySelector( '.vm-faq__answer' );
                        other.classList.remove( 'is-open' );
                        if ( otherBtn )    otherBtn.setAttribute( 'aria-expanded', 'false' );
                        if ( otherAnswer ) otherAnswer.setAttribute( 'hidden', '' );
                    } );

                    // Abre o clicado (se estava fechado)
                    if ( ! isOpen ) {
                        item.classList.add( 'is-open' );
                        btn.setAttribute( 'aria-expanded', 'true' );
                        answer.removeAttribute( 'hidden' );
                    }
                } );
            } );
        }

        return { init };
    } )();

    // ── Módulo: Header mobile (landing vm-header) ─────────────────────────────
    const LandingNav = ( function () {

        function init() {
            const toggle = document.querySelector( '.vm-header__toggle' );
            const nav    = document.querySelector( '.vm-nav' );
            if ( ! toggle || ! nav ) return;

            toggle.addEventListener( 'click', function () {
                const isOpen = nav.classList.toggle( 'is-open' );
                toggle.setAttribute( 'aria-expanded', isOpen ? 'true' : 'false' );
            } );

            document.addEventListener( 'click', function ( e ) {
                if ( ! toggle.contains( e.target ) && ! nav.contains( e.target ) ) {
                    nav.classList.remove( 'is-open' );
                    toggle.setAttribute( 'aria-expanded', 'false' );
                }
            } );
        }

        return { init };
    } )();

    // ── Módulo: Validação do campo telefone WPForms (campo ID 8, form ID 11) ──
    const WPFormsPhone = ( function () {

        // Número de telemóvel PT: 9 dígitos, começa por 2 (fixo) ou 9 (móvel)
        var FIELD_SELECTOR = '#wpforms-11-field_8';
        var PT_PHONE_RE    = /^[29]\d{8}$/;
        var ERROR_CLASS    = 'wpforms-error';
        var ERROR_ID       = 'wpforms-11-field_8-error';

        function init() {
            $( document ).on( 'input keydown paste', FIELD_SELECTOR, restrictToDigits );
            $( document ).on( 'blur', FIELD_SELECTOR, validateOnBlur );

            // Validação ao submeter — WPForms dispara este evento antes de enviar
            $( document ).on( 'wpformsBeforeFormSubmit', '#wpforms-form-11', function ( e, formId, $form ) {
                if ( ! validate( true ) ) {
                    e.preventDefault();
                }
            } );
        }

        // Impede que sejam digitados caracteres que não sejam dígitos
        function restrictToDigits( e ) {
            if ( e.type === 'keydown' ) {
                // Permite: backspace(8), delete(46), tab(9), enter(13),
                //          setas (37-40), ctrl/cmd+A/C/V/X
                var allowed = [ 8, 9, 13, 46, 37, 38, 39, 40 ];
                if (
                    allowed.indexOf( e.which ) !== -1 ||
                    ( ( e.ctrlKey || e.metaKey ) && [ 65, 67, 86, 88 ].indexOf( e.which ) !== -1 )
                ) {
                    return;
                }
                // Bloqueia tudo que não seja dígito (0-9: keyCodes 48-57 e 96-105 numpad)
                if ( ( e.which < 48 || e.which > 57 ) && ( e.which < 96 || e.which > 105 ) ) {
                    e.preventDefault();
                }
                return;
            }

            if ( e.type === 'paste' ) {
                // Limpa o clipboard de não-dígitos após o paste
                setTimeout( function () {
                    var $el = $( FIELD_SELECTOR );
                    $el.val( $el.val().replace( /\D/g, '' ) );
                }, 0 );
                return;
            }

            // input: remove qualquer não-dígito que possa ter chegado
            var $el  = $( this );
            var prev = $el.val();
            var next = prev.replace( /\D/g, '' );
            if ( prev !== next ) { $el.val( next ); }
        }

        function validate( requireFilled ) {
            var $field = $( FIELD_SELECTOR );
            if ( ! $field.length ) return true; // campo não existe nesta página

            var val    = $field.val().trim();
            var $error = $( '#' + ERROR_ID );

            // Campo vazio: só é erro se estivermos a validar no submit e o campo for obrigatório
            if ( val.length === 0 ) {
                $field.removeClass( ERROR_CLASS );
                $error.remove();
                if ( requireFilled ) {
                    showError( $field, 'Por favor, introduza o seu número de telefone.' );
                    return false;
                }
                return true;
            }

            if ( PT_PHONE_RE.test( val ) ) {
                $field.removeClass( ERROR_CLASS );
                $error.remove();
                return true;
            }

            // Número parcial/inválido
            showError( $field, 'Número inválido. Introduza 9 dígitos (ex: 912345678 ou 213456789).' );
            return false;
        }

        function showError( $field, msg ) {
            var $error = $( '#' + ERROR_ID );
            $field.addClass( ERROR_CLASS );
            if ( ! $error.length ) {
                $( '<label>', {
                    id:    ERROR_ID,
                    'for': 'wpforms-11-field_8',
                    'class': ERROR_CLASS,
                    text:  msg,
                } ).insertAfter( $field );
            } else {
                $error.text( msg );
            }
        }

        function validateOnBlur() {
            validate( false );
        }

        return { init };
    } )();

    // ── Bootstrap ─────────────────────────────────────────────────────────────
    $( document ).ready( function () {
        Navigation.init();
        StickyHeader.init();
        SmoothScroll.init();
        LazyImages.init();
        BackToTop.init();
        FaqAccordion.init();
        LandingNav.init();
        WPFormsPhone.init();
    } );

} )( jQuery, typeof valormaiaData !== 'undefined' ? valormaiaData : {} );
